/**
 * Which interactive segmentation panel is open, and on which volume.
 *
 * Separate from `useToolSession` (which owns `ToolLaunchDialog`'s own state):
 * that dialog's job ends at "which volume"; everything after — download,
 * encode, click, decode, save — belongs to a session that outlives the
 * dialog and should not reset if the dialog's own state does.
 */
import { create } from "zustand";

interface InteractiveSegState {
  open: boolean;
  toolId: string | null;
  nodeId: string | null;
  openPanel: (toolId: string, nodeId: string) => void;
  close: () => void;
}

export const useInteractiveSegStore = create<InteractiveSegState>((set) => ({
  open: false,
  toolId: null,
  nodeId: null,
  openPanel: (toolId, nodeId) => set({ open: true, toolId, nodeId }),
  close: () => set({ open: false }),
}));
